import classNames from "classnames"
import React from "react"
import { CustomCol, CustomColProps } from "../../spacings/CustomCol"
import classes from "./CollapsibleCol.module.css"

export interface CollapsibleColProps extends CustomColProps {
  collapsed?: boolean
  smooth?: boolean
}

const CollapsibleCol = ({
  className,
  collapsed,
  smooth,
  ...props
}: CollapsibleColProps) => {
  return (
    <CustomCol
      {...props}
      className={classNames(className, classes.root, {
        [classes.collapsed]: collapsed,
        [classes.smooth]: smooth,
      })}
    />
  )
}

export default CollapsibleCol
